import { openedx } from '../../shared/lib/openedx';

export interface DomainEvent {
  id: number;
  event_type: string;
  message: string;
  created_at: string;
}

export interface Domain {
  id: number;
  hostname: string;
  kind: 'primary' | 'custom';
  desired_state: 'active' | 'released';
  state: string;
  dns_status: string | null;
  expected_cname: string;
  observed_dns: string[];
  ingress_admitted: boolean | null;
  certificate_ready: boolean | null;
  certificate_reason: string | null;
  cert_not_after: string | null;
  acme_path_reachable: boolean | null;
  reachable: boolean | null;
  observed_at: string | null;
  next_retry_at: string | null;
  retry_count: number;
  last_error_code: string | null;
  last_error_message: string | null;
  events: DomainEvent[];
}

interface DomainsPayload {
  domains: Domain[];
}

const base = (slug: string) =>
  `/api/tenant/v1/tenants/${encodeURIComponent(slug)}/domains`;

export const domainsApi = {
  list: async (slug: string) => (await openedx.get<DomainsPayload>(base(slug))).domains,
  create: (slug: string, hostname: string) =>
    openedx.post<Domain>(base(slug), { hostname }),
  check: (slug: string, id: number) =>
    openedx.post<Domain>(`${base(slug)}/${id}/check`, {}),
};
